<mat-form-field class="allwidth">
    <input matInput placeholder="{{ 'IBAN' | translate}}" [value]="selectedPartnerIban?.IBAN" [disabled]="true" class="one">
    <i matSuffix *ngIf="ngControl?.control.enabled" class="glyphicon glyphicon-new-window link" (click)="selectPartnerIban()"></i>
</mat-form-field>
<error [control]="ngControl?.control"></error>
